export default "__VITE_ASSET__aZ6aLis9__"